import { Link } from 'react-router-dom';

import { Route42Logo } from '../../../components/brand/Route42Logo';
import { useTourGuide } from '../guide/tour-guide';
import { clearProductTourReturnPath, getProductTourReturnPath } from '../navigation/product-tour-return';

export function TourTopBar({ machineName, onMenu }: { machineName: string; onMenu: () => void }) {
  const guide = useTourGuide();
  const returnPath = getProductTourReturnPath();
  return (
    <header className="r42-topbar r42-tour-topbar">
      <button className="r42-icon-button r42-mobile-menu" onClick={onMenu} aria-label="Open Product Tour navigation">
        <i className="bi bi-list" aria-hidden="true" />
      </button>
      <Link className="r42-brand" to="/tour" aria-label="Route42 Product Tour home">
        <Route42Logo variant="responsive" />
      </Link>
      <div className="r42-tour-topbar__machine" aria-label="Example machine">
        <span>Example machine</span>
        <strong>{machineName}</strong>
      </div>
      <Link
        className="btn btn-sm r42-tour-exit"
        to={returnPath}
        onClick={() => {
          guide.pause();
          clearProductTourReturnPath();
        }}
      >
        Exit tour
      </Link>
    </header>
  );
}
